export default {
  'actPage.what': 'What is BIT?',
  'actPage.bit.introduce': 'BIT is the native token of the cryptocurrency exchange Biconomy.com. BIT’s value is in part reliant upon the reputation of the Biconomy crypto exchange. It comes with a wide range of applications and benefits for holders.',
  'actPage.buy': 'Buy BIT',
  'actPage.BscScan': 'BscScan Contract',
  'actPage.Benefits': 'BIT Benefits',
  'actPage.we.want': 'We want BIT token holders to have direct benefits from working with Biconomy exchange,',
  'actPage.therefore': 'therefore we offer the following utilities of the BIT token, which will allow it to become a reliable and stable asset.',
  'actPage.coming': 'coming soon',
  'actPage.save.fees_1': 'Save On Spot Trading fees',
  'actPage.save.fees_2': 'Save On Margin Trading fees',
  'actPage.save.fees_3': 'Save On Futures Trading fees',
  'actPage.cell.title_1': 'Distribution',
  'actPage.cell.text_1': '50% from the transaction operation fees will be used to repurchase and burn BIT tokens to curb inflation.',
  'actPage.cell.title_2': 'Allocation',
  'actPage.cell.text_2': 'BIT adopts a deflationary model: each transaction charges a 6% tax, which is transferred to the black hole address for destruction',
  'actPage.cell.title_3': 'Applications',
  'actPage.cell.text_3': 'BIT will be applied to smart chain, DEX, NFT and other products that will be potentially developed by Biconomy exchange to create exciting opportunities for its traders',
  'actPage.tokenomics': 'Get to know the tokenomics of the asset that powers our ecosystem',
  'actPage.platforms': 'BIT is deployed and available on various crypto platforms',
  'actPage.BscScan.copy': 'Copy BIT Token contract on BscScan',
  'actPage.copy': 'Copy Contract',
  'actPage.BscScan.btn': 'View BscScan Contract',
  'actPage.bic': 'Get BIT on Biconomy Exchange',
  'actPage.bic.btn': 'Buy BIT on Biconomy',
  'actPage.PancakeSwap': 'Use BscScan contract to buy BIT Token on PancakeSwap',
  'actPage.PancakeSwap.btn': 'Buy BIT on Pancake',
  'actPage.Caballo.get': 'Get BIT on Caballo',
  'actPage.Caballo.get.text': 'You can get BIT token on Caballo Swap in a few second by following the first link from the left and copying BIT contract from Solana Network and then following the second link to got to CaballoSwap.',
  'actPage.Solana.copy': 'Copy BIT Token contract on Solana',
  'actPage.Solana.btn': 'View Solana Contract ',
  'actPage.Caballo': 'Use Solana contract to buy BIT Token on Raydium',
  'actPage.Caballo.buy': 'Buy BIT on Caballo',
  'actPage.check': "Check BIT on {name}",
  'actPage.track': 'Track BIT Price',
  'actPage.buy_on': "Buy BIT on",
  'actPage.track_on': 'Track BIT on',
  'actPage.integrate': 'Want to integrate BIT into your product or platform?',
  'actPage.contact': 'Do not hesitate to contact us at',
  'actPage.email': 'business@biconomy.com',
  'actPage.tokenomics.title_1': 'Liquidity mining pool: 64%',
  'actPage.tokenomics.text_1': 'Circulating supply for trading on DEX and СEX.',
  'actPage.tokenomics.title_2': 'Technical team: 20%',
  'actPage.tokenomics.text_2': '5% will be unlocked one year after going online, and the rest will be released in four years. These funds will help develop new products for more comfortable and profitable trading for our users.',
  'actPage.tokenomics.title_3': 'Early Investors: 10%',
  'actPage.tokenomics.text_3': '5% unlocked after 6 months, 5% unlocked after 12 months, These tokens are intended for early investors, strategic investors and funds.',
  'actPage.tokenomics.title_4': 'Marketing and promotion: 6%',
  'actPage.tokenomics.text_4': 'Tokens without a lock, since the marketing needs are constant. Funds are spent as needed at the discretion of the exchange team.',
  'actPage.num': '1,000 billion BIT tokens',
  'actPage.num.text': ' will be available. The funds will help make exciting investment, earning and other blockchain-based innovative products for crypto enthusiasts worldwide.',
  'actPage.coinstore.get': 'Get BIT Token on Coinstore',
  'actPage.mexc.get': 'Get BIT Token on MEXC',
  'actPage.p2p.get': 'Get BIT Token on P2PB2B',
  'actPage.coinstore.btn': 'Buy BIT on Coinstore',
  'actPage.mexc.btn': 'Buy BIT on MEXC',
  'actPage.p2p.btn': 'Buy BIT on P2PB2B',
  'actPage.get.title': 'Get BIT and enjoy our ecosystem',
  'actPage.get.text': 'You can get Biconomy Exchange Token (BIT) on one of the exchanges below in a few seconds. By acquiring BIT you will become part of our growing digital ecosystem and get a chance to take advantage of our services.',
};
